const mapStoreToApplePayShippingContact = (store)=>{
    const addressLines = [];
    if (store.streetName) {
        addressLines.push(store.streetName);
    }
    if (store.streetNumber) {
        if (store.additionalStreetInfo) {
            addressLines.push(`${store.streetNumber} ${store.additionalStreetInfo}`);
        } else {
            addressLines.push(store.streetNumber);
        }
    }
    return {
        addressLines,
        postalCode: store.postalCode || '',
        locality: store.town || '',
        countryCode: store.country || '',
        subAdministrativeArea: store.province || ''
    };
};

export { mapStoreToApplePayShippingContact };
//# sourceMappingURL=store-to-apple-shipping-contact.js.map
